<!--API高级模板 API签约方由发起那边指定，不在这里操作 -->
<!--更新contractinfo信息的时候尽量选在点击下一步时-->
<template>
  <div class="wrap">
    <!--    第一步-->
    <el-form
      size="small"
      ref="contForm"
      :model="contractInfo"
      class="cont-form"
    >
      <div class="f-top">
        <el-form-item>
          <h4><i></i>模板名称</h4>
        </el-form-item>
        <el-form-item prop="tplName" :rules="myRules.tplName" class="s-er">
          <el-row style="width: 550px;">
            <el-input
              v-model="contractInfo.tplName"
              placeholder="请输入模板名称"
              :readonly="isPreview()"
              @blur="validContractName"
            />
          </el-row>
        </el-form-item>
      </div>

      <div class="f-top">
        <el-form-item>
          <h4><i></i>模板文件</h4>
        </el-form-item>
        <el-form-item>
          <div class="input-wrap">
            <!--合同-->
            <div class="input-box">
              <!--未上传-->
              <template v-if="!contractFile.fileName">
                <span class="el-icon-plus"></span><br />
                <p>上传docx/doc/pdf格式文件</p>
              </template>
              <!--上传后展示-->
              <template v-else>
                <!--fileSuffix-->
                <div class="f-box">
                  <div class="bx">
                    <img
                      v-if="fileSuffix(contractFile.fileName) === 'pdf'"
                      src="/images/advancedVersion/pdf.png"
                    />
                    <img
                      v-if="
                        fileSuffix(contractFile.fileName) === 'doc' ||
                          fileSuffix(contractFile.fileName) === 'docx'
                      "
                      src="/images/advancedVersion/word.png"
                    />
                    <!--蒙层-->
                    <div class="msk" :style="{display: isPreview() ? 'none' : ''}"><a @click="reUpload">重新上传</a></div>
                  </div>
                  <p :title="contractFile.fileName">
                    {{ contractFile.fileName }}
                  </p>
                </div>
              </template>
                <input
                  v-show="!isPreview()"
                  @change="contractFileUpload"
                  type="file"
                  ref="contractFileInput"
                />
            </div>
            <!--附件-->
            <div class="fj-wrap">
              <template v-if="!isPreview()">
                <span class="fj-box">
                  <span
                    class="icon-fj"
                    style="vertical-align: text-bottom;"
                  ></span
                  >添加附属材料（{{ enclosureFiles.length }}/3)
                  <input
                    @change="handleAttatchFileUpload"
                    type="file"
                    ref="attatchFileInput"
                  />
                </span>

                <el-tooltip effect="light" placement="bottom-start">
                  <div slot="content">
                    支持任意格式文件；<br />最多可添加3个附件，每个最大30M；<br />为固定附属材料，模板使用人可添加，不可删除<br />仅供参与方查阅，不用于签署
                  </div>
                  <i
                    class="el-icon-question"
                    style="font-size: 16px;margin-left: 10px;color: #a1a1a1;cursor: pointer;margin-right: 50px;"
                  ></i>
                </el-tooltip>
              </template>

              <template v-if="enclosureFiles && enclosureFiles.length">
                <template v-for="(item, index) in enclosureFiles">
                  <span class="fj" :key="index">
                    <span class="text">{{ item.fileName }}</span>
                    <!--<span class="size">{{Math.ceil(item.size/1024)}}KB</span>-->
                    <span
                      class="el-icon-error"
                      @click="delAttatch(item, index)"
                    ></span>
                  </span>
                </template>
              </template>
            </div>
          </div>
        </el-form-item>
      </div>
      <el-form-item class="text-center">
        <el-button class="abtn" @click="nextStep" type="danger"
          >下一步</el-button
        >
      </el-form-item>
    </el-form>
    <!--    第二步-->

    <!--    弹窗-->
    <!--确认退出弹窗-->
    <el-dialog
      title="提示"
      class="com-myDialog"
      :visible.sync="tipsDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="con">
        <p style="margin-top: 40px;">
          <span class="el-icon-warning"></span>当前内容还未保存，确认退出编辑？
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="(tipsDialogVisible = false), (sureEdit = false)"
          >继续填写</el-button
        >
        <el-button type="primary" @click="confirmEdit">仍然退出</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import md5 from "js-md5";
import { mapGetters} from "vuex";
import {
  postFileTempUpload2,
  uploadFileAndConvertInfo,
  ApiMethods,
} from "../../../assets/js/http-serve/http-methods";

import Vue from "vue";
import { formatParam } from "../advancedVersion";

function getStore() {
  return Vue.prototype.$storeInstance;
}

export default {
  name: "advancedVersionAddTpl",
  components: {},
  data() {
    return {
      loading: null,
      // 第一步
      // 授权授权范围
      // 合同信息
      contractInfo: {
        tplId: null,
        tplName: "",
        signers: [], // 签署方
        files: [], // 文件上传信息
        orderFlag: false, // 是否顺序签字
        inputGroups: [{ title: "", inputs: [] }], // 组件列表
        groupIdSet: [] // 授权多个部门 id
      },
      myRules: {
        tplName: [
          { max: 100, message: "模板名称不能超过100个字符", trigger: "change" },
          { required: true, message: "请输入模板名称", trigger: "change" }
        ]
      },
      // 上传文件
      contractFile: {}, // 上传的合同文件
      enclosureFiles: [], // 上传的附件
      signers: [],
      // 离开页面是否修改的判断
      highAuthorityPath: ["/advancedVersion/APICust/preview"], // 不需要判断可以直接跳转的路由
      sureEdit: false,
      tipsDialogVisible: false,
      toPath: "", // 拦截前用户想要前往的页面
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.path !== "/advancedVersion/setVariable") {
      // 不是下一步设置变量过来的页面，都需要清空store
      getStore()
        .dispatch("advancedVersionState/clearAddTpl")
        .then(() => {
          next();
        });
    } else {
      next();
    }
  },
  created() {
    // console.log(
    //   "advancedVersionModule数据",
    //   this.GET_addTpl_contractInfoJson,
    //   11111
    // );
    // if (
    //   this.GET_addTpl_contractInfoJson &&
    //   JSON.stringify(this.GET_addTpl_contractInfoJson) !== "{}"
    // ) {
    //   // 验证数据是否存在
    //   // 数据回显
    //   this.storeDataToPageData();
    //   // 渲染模板授权范围树状图数据
    //   this.initTreeGroup();
    // } else {
      // 初始新增或编辑
      getStore()
        .dispatch("advancedVersionState/clearAddTpl")
        .then(() => {
          this.getTemplateDetailByID();
        });
    // }
  },
  mounted() {
    window.addEventListener("beforeunload", this.leavePage);
  },
  beforeDestroy(next) {
    window.removeEventListener("beforeunload", this.leavePage);
  },
  // 页面路由更改时
  beforeRouteLeave(to, from, next) {
    if (this.canLeave(to.path)) {
      this.toPath = to.fullPath;
      this.tipsDialogVisible = true;
      next(false);
    } else {
      next(true);
    }
  },
  computed: {
    // 获取store里面的数据
    ...mapGetters("advancedVersionState", {
      GET_addTpl_recordContract: "GET_addTpl_recordContract",
      GET_addTpl_contractInfoJson: "GET_addTpl_contractInfoJson"
    }),
  },
  methods: {
    isPreview(){
      const {isPreview} = this.$route.query
      return isPreview ? true : false
    },
    // 获取文件后缀
    fileSuffix(fileName) {
      let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let namelength = fileName.length; //取到文件名长度
      let filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      return filesuffix;
    },
    validContractName: function() {
      if (this.contractInfo.tplName.length > 100) {
        return this.$message.warning("模板名称不能超过100个字符");
      }
    },
    loadingStart(info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    loadingClose() {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 业务逻辑

    // *********************第一步 start*************************
    // 获取组件列表信息
    getInputsInfo() {
      let stData = this.contractInfo;
      stData = stData && stData.inputGroups ? stData.inputGroups[0].inputs : [];
      return stData;
    },

    // ......离开页面判断 start.....
    // 刷新或者关闭页面时提示
    leavePage(e) {
      if (this.canLeave()) {
        let dialogText = "当前内容还未保存，确认退出编辑？"; // 大部分浏览器使用默认文案，这将不生效
        e = e || window.event;
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = dialogText;
        }
        // For Safari
        return dialogText;
      }
    },
    /// 确定退出
    confirmEdit() {
      this.tipsDialogVisible = false;
      this.sureEdit = true;
      this.$router.push({ path: this.toPath });
      // window.history.go(-2)
    },
    //
    /**
     * 是否可以离开页面
     * @toPath 页面要前往的地址
     * */
    canLeave(toPath) {
      return (
        this.highAuthorityPath.indexOf(toPath) === -1 &&
        !this.sureEdit &&
        this.IsPageChange()
      );
    },
    // 页面内容是否更改
    IsPageChange() {
      if (
        md5(JSON.stringify(this.GET_addTpl_recordContract)) !==
        md5(JSON.stringify(this.savedContractInfo()))
      ) {
        // 数据有更改
        return true;
      }
      return false;
    },
    /**
     * 用于存储比较用的setAddTplRecordContract信息,初次新增或者初次编辑时存储,过滤出必要的参数信息
     * 使用场景:离开页面时判断页面是否修改
     * */
    savedContractInfo() {
      return formatParam({
        tplId: this.contractInfo.tplId,
        tplName: this.contractInfo.tplName,
        orderFlag: this.contractInfo.orderFlag,
        inputGroups: this.contractInfo.inputGroups,
        signers: this.signers,
        // 文件上传信息
        files: [{ ...this.contractFile }, ...this.enclosureFiles],
        groupIdSet: [] // 授权多个部门 id
      });
    },
    // ......离开页面判断 end......

    // 。。。。。。。。。。。进入页面时候的数据回显 start。。。。。。。。。。。。。。。
    // 页面初始化时：当store有数据时数据回显store里面的数据
    storeDataToPageData() {
      // store里面的数据转换为当前需要的页面数据
      // 新增时上一步回到当前页面的回显
      let savedInfo = this.GET_addTpl_contractInfoJson; // 获取存储的变量完整信息

      this.contractInfo = savedInfo;
      // 合同信息
      this.contractFile = savedInfo.files.find(item => item.tplFileType == 1); // 1合同，2附件
      // 附件信息
      this.enclosureFiles =
        savedInfo.files.length > 1
          ? savedInfo.files.filter(item => item.tplFileType == 2)
          : [];
      // 签署方信息

      this.signers = savedInfo.signers;
      console.log("signers:", this.signers);
      // 模板授权范围
    },
    /**
     *  初始进入编辑页面时，获取构造页面显示的数据
     *  @resultData 根据模板id查询并返回的模板详情数据
     * */
    editDataToPageData(data) {
      let context = data.context;
      this.contractInfo = {
        tplId: data.tplId,
        tplName: data.tplName,
        signers: context.signers, // 签署方
        files: context.files, // 文件上传信息
        orderFlag: context.orderFlag, // 是否顺序签字
        inputGroups: context.inputGroups, // 组件列表
        groupIdSet: data.groupList // 授权多个部门 id
      };

      // 合同信息
      const FILES=this.contractInfo.files.find(
        item => item.tplFileType == 1
      );
      console.log('FILES',FILES);
      this.contractFile = FILES ? FILES :{} // 1合同，2附件
      // 附件信息
      this.enclosureFiles =
        this.contractInfo.files.length > 1
          ? this.contractInfo.files.filter(item => item.tplFileType == 2)
          : [];
      // 修改时初次进入存储信息-用于比较判断是否修改
      this.$store.dispatch(
        "advancedVersionState/setAddTplRecordContract",
        this.savedContractInfo()
      );
    },
    // 。。。。。。。。。。。进入页面时候的数据回显 end。。。。。。。。。。。。。。。

    // 下一步操作时，离开页面：将当前需要的页面数据转换为store里面的存储数据
    pageDataToStoreData(callback) {
      // 将信息存储到store
      this.$store
        .dispatch("advancedVersionState/SETAddTplContractInfoJson", {
          ...this.contractInfo,
          signers: this.signers,
          // 文件上传信息
          files: [{ ...this.contractFile }, ...this.enclosureFiles],
          groupIdSet: [] // 授权多个部门 id
        })
        .then(() => {
          callback && callback();
        });
    },
    /**
     *  获取模板详情
     * */
    getTemplateDetailByID() {
      return new Promise((resolve, reject) => {
          const {ak} =this.$route.query
          ApiMethods.TemplateController.ApiLinkInfo({ak}).then(result => {
            if (!result.success)
              return this.$message.error(result.description || this.$tip);
            this.editDataToPageData(result.data);
            this.$store.commit(
              "advancedVersionState/SET_addTpl_tplData",
              result.data
            );
            resolve();
          });
      });
    },
    // 。。。。。。。。。。。。文件上传相关 start。。。。。。
    // 合同上传
    contractFileUpload(e) {
      let file = e.target.files[0] || e.value;
      const filename_arry = file.name.split(".");
      filename_arry.splice(filename_arry.length - 1, 1);
      let fileName = filename_arry.join(".");
      // let re = new RegExp('(.jpg|.png|.bmp|.jpeg|.pdf|.doc|.docx)$', 'i');
      let re = new RegExp("(.pdf|.doc|.docx)$", "i");

      if (!re.test(file.name)) {
        e.target.value = "";
        // return this.$message.warning('文件格式只能是jpg/png/bmp/pdf/doc/docx的文件');
        return this.$message.warning("文件格式只能是pdf/doc/docx的文件");
      }

      if (file.size > 1024 * 1024 * 20) {
        e.target.value = "";
        return this.$message.warning("文件大小不能超过20M");
      }

      this.loadingStart();
      uploadFileAndConvertInfo({
        file: file,
        fileType: 1,
        fileName: fileName,
        saveSourceFile: 1
      })
        .then(data => {
          e.target.value = "";
          this.loadingClose();
          console.log("上传合同：", data);
          this.contractFile = {
            fileName: file.name,
            tplFileType: 1, // 文件类型：1合同文件 2附件
            tempFile: data.tempFile,
            sourceFile: data.sourceFile
            // "tempFile": { // 文件上传信息
            //   "sign": data.sign,
            //   "targetId": data.targetId,
            //   "ts": data.ts
            // },
          };

          !this.contractInfo.tplName && (this.contractInfo.tplName = fileName);
        })
        .catch(err => {
          e.target.value = "";
          this.loadingClose();
          this.$message.warning(err.description || "上传合同失败");
        });
    },
    // 重新上传合同
    reUpload() {
      let stData = this.getInputsInfo();
      if (stData && stData.length > 0) {
        this.$confirm("重新上传将清空已添加的变量，确定重新上传？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.contractInfo.inputGroups = [{ title: "", inputs: [] }];
            this.$refs["contractFileInput"].click();
          })
          .catch(() => {});
      } else {
        this.$refs["contractFileInput"].click();
      }
    },
    // 上传附件
    handleAttatchFileUpload(el) {
      if(this.isPreview()) return false
      if (this.enclosureFiles.length >= 3) {
        this.$message.error("附件最多只能上传3个");
        return (el.target.value = "");
      }
      el = el.target;
      let file = el.files[0] || null;
      if (!file) return false;
      if (file.size > 30 * 1024 * 1024) {
        this.$message.warning("附件大小不能超过30M!");
        return;
      }
      this.loadingStart("正在上传附件");
      postFileTempUpload2({ file: file, fileType: 1 })
        .then(data => {
          this.loadingClose();
          console.log("上传附件：", data);
          el.value = "";

          this.enclosureFiles.push({
            fileName: file.name,
            tplFileType: 2, // 文件类型：1合同文件 2附件
            tempFile: {
              // 文件上传信息
              fileType: data.fileType,
              sign: data.sign,
              targetId: data.targetId,
              ts: data.ts
            },
            // 前端辅助变量-文件大小
            size: file.size
          });
        })
        .catch(err => {
          this.loadingClose();
          el.value = "";
          this.$message.warning(err.description || "附件上传失败请重试");
        });
    },
    // 删除附件
    delAttatch(item, index) {
      this.enclosureFiles &&
        this.enclosureFiles.length &&
        this.enclosureFiles.splice(index, 1);
    },
    // 。。。。。。。。。。。。文件上传相关 end。。。。。。
    // 保存成功并跳转
    savedAndLeave() {
      this.$store.dispatch("advancedVersionState/clearAddTpl").then(() => {
        // this.$router.push({path: '/console/setting', query: {activeName: 'tab-template'}})
        this.$router.push({
          path: "/console/template",
          query: { activeName: "mianSign" }
        });
      });
    },
    // *********************第一步 end*************************

    // *********************第二步 start*************************
    postSend() {
      this.pageDataToStoreData(() => {
        this.$router.push({
          path: "/advancedVersion/APICust/preview",
          query: { ...this.$route.query,id:this.contractInfo.tplId }
        });
        // this.$router.push({
        //   path: "/editadvance/setVariable",
        //   query: { ...this.$route.query }
        // });
      });
    },

    async nextStep() {
      console.log("signers:", this.signers);
      console.log("附件:", this.enclosureFiles);

      // 验证
      if (!this.contractFile.fileName) {
        return this.$message.warning("请上传模板文件");
      }

      // 验证模板名称
      let contFormValidate = await new Promise((resolve, reject) => {
        this.$refs["contForm"].validate(valid => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
            console.log("error submit!!");
            return false;
          }
        });
      });
      if (contFormValidate) {
        // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 start《《《《
        // 签署方是企业用户且没有证件号
        this.postSend();
      } else {
        console.log("验证不通过");
      }
    }
    // *********************第二步 end*************************
  },
  layout: "fullpage",
  head: { title: "模板设置" }
};
</script>
<style scoped lang="less">
@import (less) "../../../assets/style/icon.css";

.font-elips() {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.wrap {
  max-width: 1200px;
  margin: 0 auto;
}

.tab {
  /*border: 1px dashed #dbdbdb;*/

  .list-box {
    /*padding: 15px 14px;*/
    padding: 10px 0;

    /*.sign-item {*/
    /*  &:hover {*/
    /*    background-color: #eee;*/
    /*    !*border: 1px solid #eee !important;*!*/
    /*  }*/
    /*}*/

    .i-drag:hover {
      background-color: #f8f8f8;
    }

    .i-drag:active {
      background-color: #fff2e6 !important;
    }

    .draging {
      background-color: #fff2e6;
    }

    .user-type {
      text-align: center;
      /*cursor: pointer;*/
      padding: 0 10px;

      p {
        text-align: center;
        line-height: 50px;
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
      }

      i {
        display: inline-block;
        width: 34px;
        height: 32px;
        vertical-align: super;
      }
    }

    .item {
      /*border: 1px solid #fce7e7;*/
      /*margin: 15px;*/
      display: table;
      width: 100%;
      /*width: calc(100% - 30px);*/

      .col {
        /*overflow-x: hidden;*/
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
        display: table-cell;
        /*padding-top:8px;*/
        margin-right: 10px;
        /*padding: 8px 20px 0 0;*/

        &:last-child {
          margin-right: 0;
          width: 200px;
          flex: none;
        }
      }
      /deep/ .el-checkbox__label {
        color: rgba(41, 2, 2, 0.45);
        font-size: 14px;
      }

      .final {
        /deep/ .el-form-item__content {
          justify-content: space-between;
          display: flex;
          align-items: center;
        }
      }
    }

    .icon-move_box {
      position: absolute;
      left: -5px;
      width: 15px;
      height: 15px;
      top: 50%;
      margin-top: -8px;
    }

    .icon-move_box i {
      background: url("../../../assets/images/move-icon-default.png") no-repeat
        center center;
      background-size: 100% 100%;
      width: 100%;
      height: 100%;
      /*border-right: 1px solid #fce7e7;*/
      display: block;
      /*width: 30px;*/
      /*height: 50px;*/
      /*line-height: 50px;*/
      color: #ec1c1c;
      text-align: center;
      font-size: 20px;
    }

    .icon-move_box i:hover {
      cursor: move;
      background: url("../../../assets/images/move-icon.png") no-repeat center
        center;
      background-size: 100% 100%;
    }

    li {
      margin: 10px 0 10px 10px;
      border-radius: 2px;
    }

    .col {
      display: inline-block !important;
      /deep/ .el-input__inner {
        color: #000000;
      }
    }
    .IDCard {
      /deep/ .el-input__inner {
        padding-right: 35px;
      }
    }
  }

  .radio {
    padding: 5px 14px;
    border-bottom: 1px dashed #dbdbdb;

    small {
      color: #999999;
      margin-left: 14px;
    }
  }
}

.cont-form {
  width: 100%;

  .amend-tab__form {
    display: inline-block;
    position: absolute;
    width: 30px;
    right: 0;
  }

  .el-radio.is-bordered.is-checked {
    border-color: #ec1c1c;
    color: #333333;
  }

  .checkbox {
    width: 100%;
    height: 80px;
    padding-top: 22px;

    &.end-time {
      box-sizing: border-box;
      width: 100%;
      height: 80px;
      padding: 10px;
      border: 1px solid #dcdfe6;
    }

    p.small {
      padding-left: 0px;
    }

    p.title {
      font-size: 12px;
      color: #666666 !important;
      font-weight: 600;

      i {
        box-sizing: border-box;
        color: #ec1c1c;
      }
    }

    p {
      color: #333333 !important;
      display: inline-block;
    }
  }

  div.h4,
  h4 {
    color: #290202;
    padding-top: 10px;
    line-height: 36px;
    font-size: 16px;
    margin: 0;
    font-weight: bold;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /*padding-left:15px;*/

    > i {
      display: inline-block;
      width: 5px;
      height: 15px;
      background: rgba(38, 38, 38, 1);
      opacity: 1;
      border-radius: 100px;
      margin-right: 10px;
      vertical-align: middle;
    }

    .more-set {
      line-height: 32px;
      font-size: 14px;
      margin-right: 20px;
      cursor: pointer;

      i {
        font-size: 26px;
        vertical-align: middle;
      }

      &.down i {
        animation: keyRotateToToDown 0.3s;
        transform: rotate(180deg);
      }

      &.up i {
        animation: keyRotateToUp 0.3s;
        transform: rotate(0deg);
      }

      &.down-noani i {
        transform: rotate(180deg);
      }

      &.up-noani i {
        transform: rotate(0deg);
      }
    }
  }

  /*20200526重置样式*/

  /deep/ .el-input__inner {
    height: 35px;
    line-height: 35px;
    padding-left: 10px;
  }

  .f-top {
    background-color: #ffffff;
    margin-bottom: 20px;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-row {
      padding: 20px 30px 20px 20px;
    }
  }

  .f-center {
    .f-top();

    div.h4 {
      justify-content: space-between;
      flex-wrap: nowrap;

      .el-checkbox__label {
        /*color: #000000;*/
        font-weight: normal;

        b {
          font-weight: normal;
          /*color: #000000;*/
        }
      }

      small {
        color: rgba(0, 0, 0, 0.45);
        margin-left: 5px;
      }

      .more-set {
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .wp {
      flex: auto;
      margin-left: 40px;
    }

    .radio {
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
    }

    li .el-row {
      padding: 0;
    }
  }

  .f-center2 {
    .f-top();
  }

  .f-bottom {
    .f-top();
    margin-bottom: 100px;
  }

  .bow {
    padding: 20px;
  }

  .sign-item {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    position: relative;

    > div {
      /*flex: none;*/

      &:last-child {
        flex: auto;
        text-align: right;
      }
    }
  }

  .c-btn {
    min-width: 82px;
    line-height: 25px;
    padding: 0;
    font-size: 12px;
    text-align: center;
    border: 1px solid rgba(236, 28, 28, 1);
    border-radius: 2px;
    color: #ec1c1c;

    &:hover {
      background-color: gba(236, 28, 28, 1);
      color: #ffffff;
    }
  }

  .y-btn {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    border: none;
    padding: 0;
    color: #ec1c1c;
    background: transparent !important;

    &:hover {
      opacity: 0.5;
    }
  }

  .el-icon-delete {
    color: rgba(41, 2, 2, 0.45);
    cursor: pointer;
    font-size: 16px;
    &:hover {
      color: #ec1c1c;
    }
  }

  .s-er /deep/ .el-form-item__error {
    top: 74%;
    left: 20px;
  }
}

/*文件上传*/
.input-wrap {
  box-sizing: border-box;
  padding: 30px 30px;

  .input-box {
    width: 175px;
    height: 140px;
    border: 1px solid #dcdcdc;
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    color: rgba(41, 2, 2, 0.45);
    position: relative;
    overflow: hidden;
    cursor: pointer;

    p {
      font-size: 12px;
      font-family: Source Han Sans SC;
      /*margin-top: 16px;*/
    }

    .el-icon-plus {
      margin-top: 20px;
      font-size: 60px;
    }

    input {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }

    img {
      display: block;
      margin: 0 auto;
    }

    .f-box {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      z-index: 3;
      .msk {
        overflow: hidden;
        position: absolute;
        width: 0;
        height: 0;
        left: 0;
        top: 0;
        display: none;
        z-index: 3;
        transition: all ease-in 0.2s;
        background: rgba(0, 0, 0, 0.5);
        text-align: center;
        a {
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #ffffff;
          /*margin-top: 60px;*/
          cursor: pointer;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
      }
      img {
        height: 48px;
        width: auto;
        margin-top: 28px;
      }
      .bx {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        bottom: 35px;
        z-index: 3;
        &:hover .msk {
          width: 100%;
          height: 140px;
          display: block;
        }
      }
      p {
        z-index: 1;
        position: absolute;
        left: 0;
        bottom: 0;
        .font-elips();
        padding: 0 10px;
        background: rgba(239, 239, 239, 1);
        text-align: center;
        height: 35px;
        width: 100%;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #290202;
      }
    }
  }

  /*附件*/

  .fj-wrap {
    margin-top: 33px;
    color: rgba(41, 2, 2, 0.85);
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .fj {
      display: inline-block;
      /*width: 233px;*/
      width: 170px;
      height: 30px;
      background: #f8f8f8;
      border-radius: 2px;
      position: relative;
      padding-left: 5px;
      padding-right: 10px;
      box-sizing: border-box;
      font-size: 14px;
      font-family: Source Han Sans SC;
      color: rgba(41, 2, 2, 0.85);
      margin-right: 31px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:last-of-type {
        margin-right: 0;
      }

      .text {
        display: inline-block;
        max-width: 154px;
        .font-elips();
      }

      .size {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 20px;
        color: rgba(41, 2, 2, 0.45);
        opacity: 1;
      }

      .el-icon-error {
        color: #a1a1a1;
        position: absolute;
        right: -6px;
        top: -6px;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: rgba(236, 28, 28, 1);
        }
      }
    }

    .fj-box {
      position: relative;
      cursor: pointer;
      .icon-fj {
        cursor: pointer;
      }
      &:hover {
        color: rgba(236, 28, 28, 0.85);
        .icon-fj {
          .icon-fj-on();
        }
      }
      input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
}

.row-con {
  padding: 25px 15px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.my-select {
  .font-elips();
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 360px;
  max-width: 90%;
  box-sizing: border-box;
  min-height: 35px;
  line-height: 35px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-sizing: border-box;
  color: #290202;
  text-align: left;
  padding-left: 10px;
  padding-right: 30px;
  flex-wrap: wrap;

  span {
    color: rgba(41, 2, 2, 0.45);
  }

  .tx {
    flex: none;
    .font-elips();
    color: inherit;
    display: inline-block;
    margin: 5px 5px 5px 0;
    padding-left: 5px;
    padding-right: 25px;
    position: relative;
    border-radius: 4px;
    background-color: #f4f4f5;
    box-sizing: border-box;
    vertical-align: middle;
    line-height: 25px;
    width: 100px;
    text-align: left;

    .el-icon-error {
      position: absolute;
      right: 5px;
      cursor: pointer;
      top: 50%;
      line-height: 100%;
      margin-top: -7px;
    }
  }

  .el-icon-arrow-down {
    position: absolute;
    right: 5px;
    top: 0;
    font-size: 14px;
    line-height: 35px;
  }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ec1c1c;
}

.abtn {
  line-height: 32px;
  padding: 0;
  width: 120px;
  text-align: center;
  /*font-size: 14px;*/
}
</style>
<style lang="less">
.tel-box {
  .el-table__row.current-row {
    color: #ec1c1c;
  }
}
</style>



// WEBPACK FOOTER //
// pages/advancedVersion/APICust/addTp.vue